import React, { useState } from 'react';
import { Button, Modal } from 'antd';
import { firebase } from '../../../lib/Firebase';

const { confirm } = Modal;

const SuspendButton = ({ influencerUID, children, onSuspend }) => {
  const [loading, setLoading] = useState(false);

  function showConfirmation() {
    confirm({
      title: 'Are you sure you want to remove this influencer?',
      async onOk() {
        setLoading(true);
        await firebase
          .influencer(influencerUID)
          .child('details')
          .update({
            isSuspended: true
          });
        onSuspend(influencerUID);
        setLoading(false);
      }
    });
  }

  return (
    <Button
      loading={loading}
      onClick={() => showConfirmation()}
      type="default"
      className="action-reject"
      block
    >
      {children || 'REMOVE'}
    </Button>
  );
};

export default SuspendButton;
